import { getLocaleMessages } from 'Src/locale'
import { DEFAULT_LANGUAGE } from 'Constants/Global'

const messages = getLocaleMessages(DEFAULT_LANGUAGE)

export const getCodeTranslate = (code: string): string => messages[code] || 'Отсутствует перевод'
export const i18n = (code: string): string =>
	typeof messages[code] === 'string' ? messages[code] : code || ''
